import "./ShippingReturns.module.css";
import Header from "@/reusable_sections/Header";
import Shipping from "./sections/Shipping";
import Refund from "./sections/Refund";
import Cancellation from "./sections/Cancellation";
export default function ShippingReturnsPage() {
  return <div>
      <Header />
      <Shipping />
      <Refund />
      <Cancellation />
    </div>;
}